module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    staticClass: "donate-carousel"
  }, [_c('h2', [_vm._v("Choose your pack")]), _vm._v(" "), (_vm.packages.length > 1) ? _c('div', {
    staticClass: "wwf-radio-bttns"
  }, [_vm._l((_vm.packages), function(item, index) {
    return _c('label', {
      attrs: {
        "for": 'package-' + item.code
      }
    }, [_vm._v("\n      " + _vm._s(item.display) + "\n      "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.packagecode),
        expression: "donation.packagecode"
      }],
      attrs: {
        "type": "radio",
        "name": "package",
        "id": 'package-' + item.code
      },
      domProps: {
        "value": item.code,
        "checked": index == 0 ? 'checked' : '',
        "checked": _vm._q(_vm.donation.packagecode, item.code)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.donation, "packagecode", item.code)
        }, function($event) {
          _vm.radioChanged(index)
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('package')) ? _c('p', [_vm._v("Please choose your pack")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('VueSlickCarousel', {
    ref: "adoptionCarousel",
    attrs: {
      "infinite": false,
      "arrows": false
    },
    on: {
      "afterChange": _vm.updateSelectedPackage
    }
  }, _vm._l((_vm.packages), function(item) {
    return _c('div', {
      key: item.code
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('div', {
      staticClass: "product-pack",
      style: ('background-image: url(' + item.pack.image + ')')
    }), _vm._v(" "), (item.toy) ? _c('div', {
      staticClass: "product-toy",
      style: ('background-image: url(' + item.toy.image + ')')
    }) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "product-label"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.selectedPackage.display))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.selectedPackage.pack.text) + "\n      "), (_vm.selectedPackage.toy) ? _c('span', [_vm._v(_vm._s(_vm.selectedPackage.toy.text))]) : _vm._e()])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93abe360","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/donation/AdoptionCarousel.vue
// module id = 705
// module chunks = 0